import { render, staticRenderFns } from "./CustomerDetailModal.vue?vue&type=template&id=30fe6c09&scoped=true&lang=pug"
import script from "./CustomerDetailModal.vue?vue&type=script&lang=js"
export * from "./CustomerDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fe6c09",
  null
  
)

export default component.exports